import { getNextPageParam } from "PFCore/helpers/get_next_page_param";
import {
  fetchNotificationsGroups,
  FetchNotificationsGroupsPayload,
  FetchNotificationsGroupsResponse
} from "PFCore/services/notifications/fetch_notifications_groups";
import { InfiniteQueryOptions } from "PFTypes/request_options";

import { useInfiniteQuery } from "../use_infinite_query";
import { notificationsKeys } from "./query_keys";

export const useNotificationsGroupsInfinite = (
  params: FetchNotificationsGroupsPayload,
  options: InfiniteQueryOptions<FetchNotificationsGroupsResponse> = {}
) =>
  useInfiniteQuery({
    queryKey: notificationsKeys.groups(params),
    queryFn: ({ pageParam }) => fetchNotificationsGroups({ ...params, page: pageParam }),
    getNextPageParam,
    initialPageParam: 1,
    ...options
  });
